import { useEffect, useState } from "react";
import { customStyle } from "../../algorithms/styleDirection";
import "./layoutStyle.css";
import Lang from "../../userPreferences/staticWords";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { useDispatch, useSelector } from "react-redux";
import { clearSearchKeys } from "../../API/store/actions/tasks";

const Sidebar = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login.userData);
  const changeElementActiveClass = (element) => {
    dispatch(clearSearchKeys());
    let elements = document.querySelectorAll(".item");
    let NavElements = document.querySelectorAll(".itemNav");

    let iconElements = document.querySelectorAll(".iconItem");
    let accessKey = element.currentTarget.accessKey;
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("activeClass");
      iconElements[i]?.classList.remove("activeClass");
      if (accessKey == iconElements[i]?.getAttribute("accesskey")) {
        iconElements[i].classList.add("activeClass");
      }
    }
    for (let i = 0; i < NavElements?.length; i++) {
      if (
        NavElements[i]?.children[0]?.classList?.contains("iconsActiveClass")
      ) {
        NavElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
        NavElements[i]?.classList?.remove("iconsBackgroundActiveClass");
      }
    }
    element.currentTarget.classList.add("activeClass");
  };

  let dir = getDir(getCurrentLangFromRedux());

  useEffect(() => {
    if (window.location.href.includes("task")) {
      document
        .getElementsByClassName("tasks")
        .item(0)
        .classList.add("activeClass");
      document
        .getElementsByClassName("tasks")
        .item(1)
        .classList.add("activeClass");
    }
    // else if (
    //   window.location.href.includes("project") ||
    //   window.location.href.includes("activity")
    // ) {
    //   document
    //     .getElementsByClassName("project")
    //     .item(0)
    //     .classList.add("activeClass");
    //   document
    //     .getElementsByClassName("project")
    //     .item(1)
    //     .classList.add("activeClass");
    // }
    else if (window.location.href.includes("homePage")) {
      document
        .getElementsByClassName("homePage")
        .item(0)
        .classList.add("activeClass");
      sethomeClass(true);
      document
        .getElementsByClassName("homePage")
        .item(1)
        .classList.add("activeClass");
    } else if (window.location.href.includes("workTeam")) {
      document
        .getElementsByClassName("workteam")
        .item(0)
        .classList.add("activeClass");
      document
        .getElementsByClassName("workteam")
        .item(1)
        .classList.add("activeClass");
    } else if (window.location.href.includes("notificationsIndex")) {
      document
        .getElementsByClassName("notificationsIndex")
        .item(0)
        .classList.add("activeClass");
      document
        .getElementsByClassName("notificationsIndex")
        .item(1)
        .classList.add("activeClass");
    } else if (window.location.href.includes("files")) {
      document
        .getElementsByClassName("files")
        .item(0)
        .classList.add("activeClass");
      document
        .getElementsByClassName("files")
        .item(1)
        .classList.add("activeClass");
    }
    // else if (window.location.href.includes("dashboard")) {
    //   document
    //     .getElementsByClassName("infoPanel")
    //     .item(0)
    //     .classList.add("activeClass");
    //   document
    //     .getElementsByClassName("infoPanel")
    //     .item(1)
    //     .classList.add("activeClass");
    // }
  }, []);
  const [homeClass, sethomeClass] = useState(false);

  return (
    <>
      <div
        id={`${customStyle("sidebar")}`}
        className="p-0  sideResponsive sticky-top"
        style={{ height: window.screen.availHeight }}
      >
        <div style={{ height: "inherit" }}>
          <ul className="nav stickyClass mt-4 mt-lg-0 ">
            {/* <li
              className="item project"
              onClick={(e) => {
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li1")}
              accessKey="1"
            >
              <ReactTooltip
                id={customStyle("li1")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0a58ca"
                arrowColor="#0a58ca"
              >
                <span>{Lang.projectsNavTab}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/projects"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      background:
                        "url('/assets/images/icons/projection-screen.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
                <div className="text-center text_hide">
                  {Lang.projectsNavTab}
                </div>
              </Link>
            </li> */}
            <li
              className="item homePage"
              onClick={(e) => {
                changeElementActiveClass(e);
                sethomeClass(true);
              }}
              data-tip
              data-for={customStyle("li50")}
              accessKey="50"
            >
              <ReactTooltip
                id={customStyle("li50")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span>الرئيسية</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/homePage"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    className={`${
                      homeClass == true ? "homePhotoClick" : "homePhoto"
                    }`}
                  ></div>
                </div>
                <div
                  className="text-center  text_hide"
                  style={{ color: "#0C574C" }}
                >
                  الرئيسية
                </div>
              </Link>
            </li>
            <li
              className="item links"
              onClick={(e) => {
                sethomeClass(false);
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li11")}
              accessKey="11"
              style={{ marginBottom: 20 }}
            >
              <ReactTooltip
                id={customStyle("li11")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span> التكليفات الرئاسية</span>
              </ReactTooltip>
              <Link
                style={{ width: 75 }}
                to="/presidential-assignments"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      background:
                        "url('/assets/policy.svg') 0% 0% no-repeat padding-box",
                      opacity: 1,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                    }}
                  ></div>
                </div>
                <div
                  className="text-center   text_hide"
                  style={{ color: "#0C574C" }}
                >
                  التكليفات الرئاسية
                </div>
              </Link>
            </li>
            <li
              className="item tasks"
              onClick={(e) => {
                sethomeClass(false);
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li2")}
              accessKey="2"
            >
              <ReactTooltip
                id={customStyle("li2")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span>{Lang.tasksNavTab}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/tasks/index"
                // onClick={() => window.location.replace("/tasks/index")}
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 "
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    className="icon1"
                    style={{
                      width: 24,
                      height: 24,
                      // background:
                      //   "url('/assets/images/icon1/svg') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
                <div
                  className="text-center  text_hide"
                  style={{ color: "#0C574C" }}
                >
                  {Lang.tasksNavTab}
                </div>
              </Link>
            </li>

            {/* <li
            className="item"
            onClick={(e) => {
              changeElementActiveClass(e);
            }}
            data-tip
            data-for={customStyle("li3")}
            accessKey="3"
          >
            <ReactTooltip
              id={customStyle("li3")}
              type="info"
              effect="solid"
              place={dir === "ltr" ? "right" : "left"}
              backgroundColor="#0a58ca"
              arrowColor="#0a58ca"
            >
              <span>{Lang.calenderNavTab}</span>
            </ReactTooltip>

            <a
              style={{ width: 65 }}
              href="#"
              className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
            >
              <div
                style={{
                  backgroundColor: "white",
                  height: 32,
                  width: 32,
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
                className="d-flex justify-content-center text-center align-items-center my-1"
              >
                <div
                  style={{
                    width: 24,
                    height: 24,
                    background:
                      "url('/assets/images/icons/fi-br-calendar.png') 0% 0% no-repeat padding-box",
                    opacity: 1,
                  }}
                ></div>
              </div>
              <div className="text-center   text_hide">
                {Lang.calenderNavTab}
              </div>
            </a>
          </li>
*/}
            {/* <li
              className="item discussion"
              onClick={(e) => {
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li4")}
              accessKey="4"
            >
              <ReactTooltip
                id={customStyle("li4")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span>{Lang.discussionCirclesNavTab}</span>
              </ReactTooltip>

              <Link
                style={{ width: 65 }}
                to={"/discussion"}
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      background:
                        "url('/assets/images/icons/fi-br-comments.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
                <div className="text-center   text_hide">
                  {Lang.discussionCirclesNavTab}
                </div>
              </Link>
            </li> */}

            {/* <li
              className="item files"
              onClick={(e) => {
                sethomeClass(false);
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li5")}
              accessKey="5"
            >
              <ReactTooltip
                id={customStyle("li5")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span>{Lang.filesNavTab}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/files"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      background:
                        "url('/assets/images/icons/fi-br-folder.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
                <div className="text-center   text_hide">
                  {Lang.filesNavTab}
                </div>
              </Link>
            </li> */}

            {/* <li
            className="item infoPanel"
            onClick={(e) => {
              changeElementActiveClass(e);
            }}
            data-tip
            data-for={customStyle("li6")}
            accessKey="6"
          >
            <ReactTooltip
              id={customStyle("li6")}
              type="info"
              effect="solid"
              place={dir === "ltr" ? "right" : "left"}
              backgroundColor="#0C574C"
              arrowColor="#0C574C"
            >
              <span>{Lang.infoPanelNavTab}</span>
            </ReactTooltip>
            <Link
              // target="_blank"
              style={{ width: 65 }}
              // href={
              //   'http://41.128.217.155/powerbi/?id=ef59641d-b626-4905-ba70-f11dd63e8313&formatLocale=ar-EG&hostdata=%7B"Build":"15.0.1107.165","ExternalUser":"True","IsPublicBuild":true,"Host":"Microsoft.ReportingServices.Portal.Services","HashedUserId":"8FF666F4A996AF59381B2885D33DA0405F28F2F86B6596E82F8DB21B195E8838","InstallationId":"006f606c-0a14-46d5-9322-aa66fa658a6d","IsEnabled":true,"Edition":"PBIRS%20SQL%20EESA","AuthenticationTypes":"RSWindowsNTLM","NumberOfProcessors":2,"NumberOfCores":4,"IsVirtualMachine":true,"MachineId":"7A7B9F941404B232F23AF929EF6A33B8","CountInstances":1,"Count14xInstances":0,"Count13xInstances":0,"Count12xInstances":0,"Count11xInstances":0,"ProductSku":"SSRSPBI","PortalVersion":"2"%7D'
              // }
              to={"/dashboard"}
              className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
            >
              <div
                style={{
                  backgroundColor: "white",
                  height: 32,
                  width: 32,
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
                className="d-flex justify-content-center text-center align-items-center my-1"
              >
                <div
                  style={{
                    width: 24,
                    height: 24,
                    background:
                      "url('/assets/images/icons/fi-br-signal-alt-1.png') 0% 0% no-repeat padding-box",
                    opacity: 1,
                  }}
                ></div>
              </div>
              <div className="text-center text_hide">
                {Lang.infoPanelNavTab}
              </div>
            </Link>
          </li> */}

            <li
              className="item workteam"
              onClick={(e) => {
                sethomeClass(false);
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li7")}
              accessKey="7"
            >
              <ReactTooltip
                id={customStyle("li7")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span>{Lang.workTeam}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/workTeam"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    className="icon3"
                    style={{
                      width: 30,
                      height: 30,
                      // background:
                      //   "url('/assets/images/icons/group (3).png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                    }}
                  ></div>
                </div>
                <div
                  className="text-center text_hide"
                  style={{ color: "#0C574C" }}
                >
                  {Lang.workTeam}
                </div>
              </Link>
            </li>

            <li
              className="item notificationsIndex"
              onClick={(e) => {
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li6")}
              accessKey="6"
            >
              <ReactTooltip
                id={customStyle("li6")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span>مؤشر أداء المحاور</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/axis"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      background:
                        "url('/assets/images/icons/fi-br-signal-alt-1.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                    }}
                  ></div>
                </div>
                <div
                  className="text-center text_hide"
                  style={{ color: "#0C574C" }}
                >
                  {" "}
                  <span>مؤشر أداء المحاور</span>
                </div>
              </Link>
            </li>
            {/* <li
              className="item discussion"
              onClick={(e) => {
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li4")}
              accessKey="4"
            >
              <ReactTooltip
                id={customStyle("li4")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span>{Lang.discussionCirclesNavTab}</span>
              </ReactTooltip>

              <Link
                style={{ width: 65 }}
                to={"/discussion"}
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      background:
                        "url('/assets/images/icons/fi-br-comments.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
                <div className="text-center   text_hide">
                  {Lang.discussionCirclesNavTab}
                </div>
              </Link>
            </li> */}

            {user?.isAdmin && (
              <li
                className="item files"
                onClick={(e) => {
                  sethomeClass(false);
                  changeElementActiveClass(e);
                }}
                data-tip
                data-for={customStyle("li5")}
                accessKey="5"
              >
                <ReactTooltip
                  id={customStyle("li5")}
                  type="info"
                  effect="solid"
                  place={dir === "ltr" ? "right" : "left"}
                  backgroundColor="#0C574C"
                  arrowColor="#0C574C"
                >
                  <span> مؤشر أداء الجهات</span>
                </ReactTooltip>
                <Link
                  style={{ width: 75 }}
                  to="/entityAxis"
                  className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      height: 32,
                      width: 32,
                      cursor: "pointer",
                      borderRadius: "50%",
                    }}
                    className="d-flex justify-content-center text-center align-items-center my-1"
                  >
                    <div
                      style={{
                        width: 22,
                        height: 22,
                        background:
                          "url('/assets/images/icons/fi-br-signal-alt-1.png') 0% 0% no-repeat padding-box",
                        opacity: 1,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                      }}
                    ></div>
                  </div>
                  <div
                    className="text-center   text_hide"
                    style={{ color: "#0C574C" }}
                  >
                    مؤشر أداء الجهات
                  </div>
                </Link>
              </li>
            )}
            {/* 
            <li
              className="item links"
              onClick={(e) => {
                sethomeClass(false);
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li8")}
              accessKey="8"
            >
              <ReactTooltip
                id={customStyle("li8")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span> اﺳﺘﻌﺮاض أجندة الفعاليات والروابط الهامة </span>
              </ReactTooltip>
              <Link
                style={{ width: 75 }}
                to="/agendaAndlinks"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      background:
                        "url('/assets/images/icons/fi-br-calendar.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                    }}
                  ></div>
                </div>
                <div
                  className="text-center   text_hide"
                  style={{ color: "#0C574C" }}
                >
                  اﺳﺘﻌﺮاض أجندة الفعاليات والروابط الهامة
                </div>
              </Link>
            </li> */}
            <li
              className="item links"
              onClick={(e) => {
                sethomeClass(false);
                changeElementActiveClass(e);
              }}
              data-tip
              data-for={customStyle("li9")}
              accessKey="9"
            >
              <ReactTooltip
                id={customStyle("li9")}
                type="info"
                effect="solid"
                place={dir === "ltr" ? "right" : "left"}
                backgroundColor="#0C574C"
                arrowColor="#0C574C"
              >
                <span> أجندة الفعاليات </span>
              </ReactTooltip>
              <Link
                style={{ width: 75 }}
                to="/agendaManagemnt"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 32,
                    width: 32,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      background:
                        "url('/assets/images/icons/fi-br-calendar.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                    }}
                  ></div>
                </div>
                <div
                  className="text-center   text_hide"
                  style={{ color: "#0C574C" }}
                >
                  أجندة الفعاليات
                </div>
              </Link>
            </li>
            {user?.isAdmin && (
              <li
                className="item links"
                onClick={(e) => {
                  sethomeClass(false);
                  changeElementActiveClass(e);
                }}
                data-tip
                data-for={customStyle("li9")}
                accessKey="9"
              >
                <ReactTooltip
                  id={customStyle("li9")}
                  type="info"
                  effect="solid"
                  place={dir === "ltr" ? "right" : "left"}
                  backgroundColor="#0C574C"
                  arrowColor="#0C574C"
                >
                  <span> الروابط الهامة </span>
                </ReactTooltip>
                <Link
                  style={{ width: 75 }}
                  to="/linksManagemnt"
                  className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      height: 32,
                      width: 32,
                      cursor: "pointer",
                      borderRadius: "50%",
                    }}
                    className="d-flex justify-content-center text-center align-items-center my-1"
                  >
                    <div
                      style={{
                        width: 22,
                        height: 22,
                        background:
                          "url('/assets/images/icons/links.png') 0% 0% no-repeat padding-box",
                        opacity: 1,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                      }}
                    ></div>
                  </div>
                  <div
                    className="text-center   text_hide"
                    style={{ color: "#0C574C" }}
                  >
                    الروابط الهامة
                  </div>
                </Link>
              </li>
            )}
          </ul>
        </div>
        <div
          className="line_style"
          style={{
            width: 1.5,
            backgroundColor: "#00000029",
            height: window.screen.availHeight + 90,
          }}
        ></div>
      </div>
    </>
  );
};

export default Sidebar;
